<template>
  <div class="member__rights">
    <!-- navbar -->
    <div :class='["member__rights__navbar", `selected_${selected}_${isVip}`]'>
      <div :class='["member__rights__navbar-item", selected===1&&"selected"]' @click="tabBar(1)"><span
          class="blob">精选</span><span class="detail">会员专享商品</span></div>
      <div v-if="vipType===2" class="member__rights__navbar-line"></div>
      <!--            <div :class='["member__rights__navbar-item", selected===2&&"selected"]'  @click="tabBar(2)"><span class="blob">生活特权</span><span>吃喝玩乐</span></div>-->
      <div v-if="vipType===2" :class='["member__rights__navbar-item", selected===3&&"selected"]' @click="tabBar(3)">
        <span class="blob">优惠券</span><span class="detail">会员专享神器</span></div>
    </div>

    <!-- tab-container -->
    <div>
      <div v-if="selected===1">
        <recommend :goods="goods"></recommend>
      </div>
      <!--            <div v-if="selected===2">-->
      <!--                <privilege></privilege>-->
      <!--            </div>-->
      <div v-if="selected===3">
        <coupon :coupons="coupons"></coupon>
      </div>
    </div>
  </div>
</template>
<script>
import Privilege from '../Privilege';
import Recommend from '../Recommend';
import Coupon from '../Coupon';

export default {
  props: {
    coupons: {
      type: Array,
    },
    goods: {
      type: Array,
    },
    vipType: {
      type: Number,
    },
  },
  components: {
    Privilege, Recommend, Coupon,
  },
  data() {
    return {
      selected: 1,
      isVip: 1,
    };
  },
  methods: {
    tabBar(selected) {
      this.selected = selected;
    },
  },
};
</script>
<style lang="scss" scoped>
.member {
  &__rights {
    &__navbar {
      background-color: rgba(0, 0, 0, 0);
      text-align: center;

      &-item {
        display: inline-block;
        padding: 0 85px;
      }

      &-line {
        display: inline-block;
        width: 2px;
        height: 60px;
        background: rgba(216, 216, 216, 1);
      }

      &-item.selected .blob {
        color: rgba(186, 133, 69, 1);
        background: none;
      }

      &-item.selected .detail {
        background-color: rgba(186, 133, 69, 1);
        color: #fff;
      }

      .detail {
        display: block;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(136, 136, 136, 1);
        padding: 2px 5px;
        border-radius: 5px;
      }

      .blob {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-bottom: 10px;
        color: #000;
      }
    }

    &__navbar.selected_1_0::after {
      left: 250px;
    }

    &__navbar.selected_2_0::after {
      left: 450px;
    }

    &__navbar.selected_1_1::after {
      left: 150px;
    }

    &__navbar.selected_2_1::after {
      left: 350px;
    }

    &__navbar.selected_3_1::after {
      left: 550px;
    }

  }

}
</style>
